import { createReducer } from 'reduxsauce'
import {
  IMAGE_UPLOAD_SUCCEEDED,
  IMAGE_UPLOAD_FAILED,
  SAVE_IMAGE_INFO,
  IMAGE_CONVERT_REQUESTED,
  IMAGE_CONVERT_SUCCEEDED,
  DELETE_IMAGE,
  SAVE_IMAGE_DATA,
  IMAGE_CONVERT_FAILED,
  SET_IMAGE_ERROR,
  SET_SAMPLE_IMAGE,
  SET_IMAGE_SRC,
} from '../types/image.types'

export const INITIAL_STATE = {
  imageSrc: '',
  imageSrcUploaded: '',
  imageData: null,
  imageName: '',
  imageFormat: '',
  imageType: '',
  imageToDownload: '',
  imageSize: 0,
  isError: false,
  isSyncError: false
}

export const setImage = (state = INITIAL_STATE, { payload: imageSrc }) => ({ ...state, imageSrc })
export const setUploadedImage = (state = INITIAL_STATE, { payload: imageSrcUploaded }) => ({ ...state, imageSrcUploaded })
export const imageUploadFail = (state = INITIAL_STATE) => ({ ...state, isSyncError: true })
export const saveImageData = (state = INITIAL_STATE, { payload: data }) => ({ ...state, imageData: data })
export const deleteImage = (state = INITIAL_STATE) => ({ ...state, imageSrc: '', imageSrcUploaded: '', imageData: null, isError: false, isSyncError: false })
export const saveImageInfo = (state = INITIAL_STATE, { payload: { name, format, type } }) => ({
  ...state,
  imageFormat: format,
  imageName: name,
  imageType: type,
})
export const imageConvert = (state = INITIAL_STATE) => ({ ...state, imageToDownload: '' })
export const imageConvertSuccess = (state = INITIAL_STATE, { payload: { imageToDownload, imageSize } }) => ({
  ...state,
  imageToDownload,
  imageSize: +imageSize,
})
export const imageConvertFailed = (state = INITIAL_STATE) => ({ ...state, isError: true })
export const setImageError = (state = INITIAL_STATE, { payload: isError }) => ({ ...state, isError })

export const HANDLERS = {
  [IMAGE_UPLOAD_SUCCEEDED]: setUploadedImage,
  [SET_SAMPLE_IMAGE]: setImage,
  [SET_IMAGE_SRC]: setImage,
  [IMAGE_UPLOAD_FAILED]: imageUploadFail,
  [DELETE_IMAGE]: deleteImage,
  [SAVE_IMAGE_INFO]: saveImageInfo,
  [IMAGE_CONVERT_REQUESTED]: imageConvert,
  [IMAGE_CONVERT_SUCCEEDED]: imageConvertSuccess,
  [IMAGE_CONVERT_FAILED]: imageConvertFailed,
  [SAVE_IMAGE_DATA]: saveImageData,
  [SET_IMAGE_ERROR]: setImageError,
}

export default createReducer(INITIAL_STATE, HANDLERS)
